import { Zap } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { useCredits } from "@/hooks/useCredits";
import { Skeleton } from "@/components/ui/skeleton";

interface CreditsDisplayProps {
  showProgress?: boolean;
  maxCredits?: number;
}

export function CreditsDisplay({ showProgress = true, maxCredits = 500 }: CreditsDisplayProps) {
  const { balance, creditsLoading } = useCredits();

  if (creditsLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-8 w-12" />
        {showProgress && <Skeleton className="h-1.5 w-full" />}
      </div>
    );
  }

  const progressValue = Math.min((balance / maxCredits) * 100, 100);

  return (
    <div className="rounded-2xl bg-gradient-to-br from-primary/20 via-violet/20 to-accent/20 border border-primary/30 p-4 animate-pulse-glow">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-foreground">Crédits</span>
        <Zap className="w-4 h-4 text-highlight" />
      </div>
      <div className="text-2xl font-bold text-foreground mb-1">{balance}</div>
      {showProgress && (
        <>
          <Progress value={progressValue} className="h-1.5 mb-2" />
          <p className="text-xs text-muted-foreground">
            {balance} / {maxCredits} crédits
          </p>
        </>
      )}
    </div>
  );
}
